export default {"src":"/_next/static/media/BlossmLogoPrimaryColor.9775e344.svg","height":23,"width":22,"blurWidth":0,"blurHeight":0};